import vue from "vue";
import Vuex from "vuex";
import { validatenull } from "./validate";
import { geturl, geturltime, posturl } from "./ajax";

vue.use(Vuex);

const TokenKey = "bj-access-token_" + document.domain;

const keyName = "bjweb-";
/**
 * 存储localStorage
 */
export const setStore = (params = {}) => {
    let { name, content, type } = params;
    name = keyName + name;
    let obj = {
        dataType: typeof content,
        content: content,
        type: type,
        datetime: new Date().getTime()
    };
    if (type) window.sessionStorage.setItem(name, JSON.stringify(obj));
    else window.localStorage.setItem(name, JSON.stringify(obj));
};
/**
 * 获取localStorage
 */

export const getStore = (params = {}) => {
    let { name, debug } = params;
    name = keyName + name;
    let obj = {},
        content;
    obj = window.sessionStorage.getItem(name);
    if (validatenull(obj)) obj = window.localStorage.getItem(name);
    if (validatenull(obj)) return;
    try {
        obj = JSON.parse(obj);
    } catch (e) {
        return obj;
    }
    if (debug) {
        return obj;
    }
    if (obj.dataType == "string") {
        content = obj.content;
    } else if (obj.dataType == "number") {
        content = Number(obj.content);
    } else if (obj.dataType == "boolean") {
        content = eval(obj.content);
    } else if (obj.dataType == "object") {
        content = obj.content;
    }
    return content;
};
/**
 * 删除localStorage
 */
export const removeStore = (params = {}) => {
    let { name, type } = params;
    name = keyName + name;
    if (type) {
        window.sessionStorage.removeItem(name);
    } else {
        window.localStorage.removeItem(name);
    }
};

/**
 * 获取全部localStorage
 */
export const getAllStore = (params = {}) => {
    let list = [];
    let { type } = params;
    if (type) {
        for (let i = 0; i <= window.sessionStorage.length; i++) {
            list.push({
                name: window.sessionStorage.key(i),
                content: getStore({
                    name: window.sessionStorage.key(i),
                    type: "session"
                })
            });
        }
    } else {
        for (let i = 0; i <= window.localStorage.length; i++) {
            list.push({
                name: window.localStorage.key(i),
                content: getStore({
                    name: window.localStorage.key(i)
                })
            });
        }
    }
    return list;
};

/**
 * 清空全部localStorage
 */
export const clearStore = (params = {}) => {
    let { type } = params;
    if (type) {
        window.sessionStorage.clear();
    } else {
        window.localStorage.clear();
    }
};

const $STORE = new Vuex.Store({
    state: {
        closeHelpXQ: false,
        IsLogin: false,
        Title: "自助报价",
        Image: "",
        ICP: "",
        AnQuanBeiAn: "",
        Company: "",
        Site: "",
        TouXiang: "",
        HideHanShu: false,
        ShowJiaGe: true,
        WWWHTTP: "",
        WWWNAME: "",
        citys: "",
        Name: "",
        Info: "",
        ZhuanBanOrZuShu: "",
        BJJinESFTuChu: false,
        //不可见公式
        GongShi: "0",
        CurrentTitle: "",
        SiteType: "", //站点类型，如果是base，就是小版本，否则就是大版本
        //皮肤样式
        ThemeName: getStore({ name: "themeName" }) || "theme-default",
        ColorName: getStore({ name: "colorName" }) || "#409EFF",
        //默认是老的订单版本
        OrderType: "0",
        DuoJiaGe: "0",
        KeXiaDan: "0",
        YeWuYuan: "0" // 是否业务员登录
    },

    mutations: {
        Login: state => (state.IsLogin = true),
        Exit: state => (state.IsLogin = false),
        SET_THEME_NAME: (state, themeName) => {
            state.ThemeName = themeName;
            setStore({
                name: "themeName",
                content: state.ThemeName
            });
        },
        SET_COLOR_NAME: (state, colorName) => {
            state.ColorName = colorName;
            setStore({
                name: "colorName",
                content: state.ColorName
            });
        },
        closeXiangqing: (state, params) => {
            state.closeHelpXQ = params;
        }
    }
});

export { $STORE };

//检查用户是否处于登录状态
const _ = function() {
    //console.log("获取用户信息。。。");
    //console.log("laiyuan-->" + sessionStorage.getItem("laiyuan"));
    let userStr;
    if (sessionStorage.getItem("laiyuan") == "pc") {
        userStr = localStorage.getItem(TokenKey);
    } else {
        userStr = sessionStorage.getItem(TokenKey);
    }
    if (userStr) {
        let user = JSON.parse(userStr);
        if (user.time < new Date().getTime() / 1000) return null;

        return user;
    } else {
        //设置不是登录状态
        $STORE.state.IsLogin = false;
        return null;
    }
};
// 从cookies中得到Token
export function getUSER() {
    return _();
}

// 设置token
export function setUSER(user) {
    // 多少秒后过期
    // let inFifteenMinutes = new Date(new Date().getTime() + second * 1000)
    if (user == null) {
        if (sessionStorage.getItem("laiyuan") == "pc") {
            localStorage.removeItem(TokenKey);
        } else {
            sessionStorage.removeItem(TokenKey);
        }
        $STORE.state.YeWuYuan = 0;
        $STORE.commit("Exit");
        return;
    }
    $STORE.commit("Login");
    if (sessionStorage.getItem("laiyuan") == "pc") {
        localStorage.setItem(TokenKey, JSON.stringify(user));
    } else {
        sessionStorage.setItem(TokenKey, JSON.stringify(user));
    }

    $STORE.state.TouXiang = user.TouXiang;
    $STORE.state.Name = user.Name;
    $STORE.state.YeWuYuan = user.YeWuYuan;
}

export function checkUSER() {
    // 多少秒后过期
    // let inFifteenMinutes = new Date(new Date().getTime() + second * 1000)
    let u = _();
    if (u) {
        $STORE.commit("Login");
        $STORE.state.TouXiang = u.TouXiang;
        $STORE.state.Name = u.Name;
        $STORE.state.YeWuYuan = u.YeWuYuan;
    }
}

// 从cookies中得到Token
export function getGUID() {
    return localStorage.getItem("BJ-GUID");
}

// 设置token
export function setGUID(guid) {
    // 几乎不过期，给本地设置一个缓存key，保持唯一性
    return localStorage.setItem("BJ-GUID", guid);
}


// WEBPACK FOOTER //
// ./src/auth.js